import { useQuery } from '@tanstack/react-query';
import { settingsService } from '../services/settings.service';

export function useSubscription() {
  return useQuery({
    queryKey: ['subscription'],
    queryFn: () => settingsService.getSubscription(),
  });
}
